export default "__VITE_ASSET__346ad92f__"